module.exports = __webpack_public_path__ + "img/tyzsbgfdyh.3216d5db.png";